// const React = window.React = require('react');
import React from "react";
import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import _ from 'lodash';
import { useTranslation } from "react-i18next/hooks";

import Loader from "../../components/Loader/Loader";
import Paginator from "../../components/Paginator/Paginator";
// import UserAdElementsItem from "../../components/UserAdElements/UserAdElementsItem";

import { useStore } from "../../hook-store/store";
import { 
  getPageNotification,
  createTestPageNotification,
  updatePageNotificationLastOpenTime,
  updatePageNotificationReadState,
 } from "../../util/page-notification/page-notification";

// import { getUserDataForStore } from "../../util/user";
// import { getUserAdElements } from "../../util/ad-visit";
// import { getAdElementsForAdmin, isAdminUser } from "../../util/admin-ad-element";

import { BASE_URL } from "../../App";

import './PageNotificationItem.css';
// import classes from './AdminAdElements.module.css';

const PageNotificationItem = (props) => {
  const { 
    notify,
    showNotificationHandler,
   } = props;

  const perPagePost = 20;

  const [t] = useTranslation("translation");

  const [store, dispatch] = useStore();
  const { userAdElements } = store;
  // const { userPageNotification } = store.pageNotificationStore;
  // console.log('store in AdminAdElements.js', store);

  const [isLoading, setIsLoading] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [newNotfiyNum, setNewNotifyNum] = useState(0);

  // const [suggestId, setSuggestId] = useState('');
  const [pageNum, setPageNum] = useState(1);


  const updateReadStateHandler = async (id, readState) => {
    try {
      setIsLoading(true);
      const resData = await updatePageNotificationReadState(
        BASE_URL, 
        localStorage.getItem('token'),
        id,
        readState,
      );

      if (resData && resData.data) {
        dispatch('SET_USERPAGENOTIFICATION', resData.data);
      }
      // console.log(adList);
      setIsLoading(false);
    } catch(err) {
      console.log(err);
      setIsLoading(false);
    }
  };



  let pageNotificationItemBody;

  
  if (notify) {
    let linkEl;

    let displayTime = new Date(notify.creationTime).toLocaleDateString();

    if (notify.creationTime > Date.now() - 1000*60*60*12) {
      displayTime = new Date(notify.creationTime).toLocaleTimeString();
    }


    if (notify.dbInfo && notify.dbInfo.dataId && notify.dbInfo.schema === 'AdElement') {
      const adElement = userAdElements.find(ad => {
        return ad._id === notify.dbInfo.dataId;
      });

      if (adElement) {
        linkEl = (
          <Link 
            to={`/ad-element/${adElement.adElementId}`}
            onClick={showNotificationHandler}
          >
            ad page
          </Link>
        );
      }
    }

    pageNotificationItemBody = (
      <div className="pageNotificationItem">
        {/* <div>{notify._id}</div> */}
        <div>
          <strong>{notify.title}</strong>
        </div>
        <div>
          {notify.message}
        </div>

        <div className="pageNotificationItemLink">
          {linkEl}
        </div>


        <div className="pageNotificationItemTime">
          {displayTime}
        </div>
        {/* {JSON.stringify(notify.dataForNotification)}
        <button 
        onClick={() => {
          updateReadStateHandler(notify._id, 'read')
        }}
        >
          update-read-state
        </button> */}
      </div>
    );
  }



  return (
    <Fragment>
      <div>{pageNotificationItemBody}</div>
    </Fragment>
  );
};

export default PageNotificationItem;
